// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Next = require("../../../reason/next/Next.bs.js");
var Sentry = require("../../../reason/Sentry.bs.js");
var Scalars = require("../../../scalars/Scalars.bs.js");
var V4 = require("uuid/v4");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Core__Result = require("@rescript/core/src/Core__Result.bs.js");
var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RelayRuntime = require("relay-runtime");
var SystemMessages = require("../../../reason/systemMessages/SystemMessages.bs.js");
var PropertyPriceInput = require("../propertyForms/PropertyPriceInput.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
var RecordPropertyCreatedEvent = require("../../../reason/clients/graphql/RecordPropertyCreatedEvent.bs.js");
var RentalPropertyAttributesInput = require("../propertyForms/RentalPropertyAttributesInput.bs.js");
var ForSalePropertyAttributesInput = require("../propertyForms/ForSalePropertyAttributesInput.bs.js");
var PropertyWizardFormRelayMutations_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayMutations_draft_graphql.bs.js");
var PropertyWizardFormRelayMutations_EditRentalPropertyMutation_graphql = require("../../../__generated__/PropertyWizardFormRelayMutations_EditRentalPropertyMutation_graphql.bs.js");
var PropertyWizardFormRelayMutations_EditForSalePropertyMutation_graphql = require("../../../__generated__/PropertyWizardFormRelayMutations_EditForSalePropertyMutation_graphql.bs.js");
var PropertyWizardFormRelayMutations_BroadcastRentalPropertyMutation_graphql = require("../../../__generated__/PropertyWizardFormRelayMutations_BroadcastRentalPropertyMutation_graphql.bs.js");
var PropertyWizardFormRelayMutations_BroadcastForSalePropertyMutation_graphql = require("../../../__generated__/PropertyWizardFormRelayMutations_BroadcastForSalePropertyMutation_graphql.bs.js");
var PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation_graphql = require("../../../__generated__/PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation_graphql.bs.js");
var PropertyWizardFormRelayMutations_RebroadcastRentalPropertyV5Mutation_graphql = require("../../../__generated__/PropertyWizardFormRelayMutations_RebroadcastRentalPropertyV5Mutation_graphql.bs.js");
var PropertyWizardFormRelayMutations_RebroadcastForSalePropertyV5Mutation_graphql = require("../../../__generated__/PropertyWizardFormRelayMutations_RebroadcastForSalePropertyV5Mutation_graphql.bs.js");

var convertVariables = PropertyWizardFormRelayMutations_BroadcastForSalePropertyMutation_graphql.Internal.convertVariables;

var convertResponse = PropertyWizardFormRelayMutations_BroadcastForSalePropertyMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = PropertyWizardFormRelayMutations_BroadcastForSalePropertyMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, PropertyWizardFormRelayMutations_BroadcastForSalePropertyMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use = RescriptRelay_Mutation.useMutation(convertVariables, PropertyWizardFormRelayMutations_BroadcastForSalePropertyMutation_graphql.node, convertResponse, convertWrapRawResponse);

var BroadcastForSalePropertyMutation_mlsListingTypeV5_decode = PropertyWizardFormRelayMutations_BroadcastForSalePropertyMutation_graphql.Utils.mlsListingTypeV5_decode;

var BroadcastForSalePropertyMutation_mlsListingTypeV5_fromString = PropertyWizardFormRelayMutations_BroadcastForSalePropertyMutation_graphql.Utils.mlsListingTypeV5_fromString;

var BroadcastForSalePropertyMutation_showingTypeV5_decode = PropertyWizardFormRelayMutations_BroadcastForSalePropertyMutation_graphql.Utils.showingTypeV5_decode;

var BroadcastForSalePropertyMutation_showingTypeV5_fromString = PropertyWizardFormRelayMutations_BroadcastForSalePropertyMutation_graphql.Utils.showingTypeV5_fromString;

var BroadcastForSalePropertyMutation = {
  mlsListingTypeV5_decode: BroadcastForSalePropertyMutation_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: BroadcastForSalePropertyMutation_mlsListingTypeV5_fromString,
  showingTypeV5_decode: BroadcastForSalePropertyMutation_showingTypeV5_decode,
  showingTypeV5_fromString: BroadcastForSalePropertyMutation_showingTypeV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

var convertVariables$1 = PropertyWizardFormRelayMutations_BroadcastRentalPropertyMutation_graphql.Internal.convertVariables;

var convertResponse$1 = PropertyWizardFormRelayMutations_BroadcastRentalPropertyMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse$1 = PropertyWizardFormRelayMutations_BroadcastRentalPropertyMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$1, PropertyWizardFormRelayMutations_BroadcastRentalPropertyMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

var use$1 = RescriptRelay_Mutation.useMutation(convertVariables$1, PropertyWizardFormRelayMutations_BroadcastRentalPropertyMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

var BroadcastRentalPropertyMutation_leaseLengthValue_decode = PropertyWizardFormRelayMutations_BroadcastRentalPropertyMutation_graphql.Utils.leaseLengthValue_decode;

var BroadcastRentalPropertyMutation_leaseLengthValue_fromString = PropertyWizardFormRelayMutations_BroadcastRentalPropertyMutation_graphql.Utils.leaseLengthValue_fromString;

var BroadcastRentalPropertyMutation_mlsListingTypeV5_decode = PropertyWizardFormRelayMutations_BroadcastRentalPropertyMutation_graphql.Utils.mlsListingTypeV5_decode;

var BroadcastRentalPropertyMutation_mlsListingTypeV5_fromString = PropertyWizardFormRelayMutations_BroadcastRentalPropertyMutation_graphql.Utils.mlsListingTypeV5_fromString;

var BroadcastRentalPropertyMutation = {
  leaseLengthValue_decode: BroadcastRentalPropertyMutation_leaseLengthValue_decode,
  leaseLengthValue_fromString: BroadcastRentalPropertyMutation_leaseLengthValue_fromString,
  mlsListingTypeV5_decode: BroadcastRentalPropertyMutation_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: BroadcastRentalPropertyMutation_mlsListingTypeV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation$1,
  use: use$1
};

var convertVariables$2 = PropertyWizardFormRelayMutations_EditForSalePropertyMutation_graphql.Internal.convertVariables;

var convertResponse$2 = PropertyWizardFormRelayMutations_EditForSalePropertyMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse$2 = PropertyWizardFormRelayMutations_EditForSalePropertyMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation$2 = RescriptRelay_Mutation.commitMutation(convertVariables$2, PropertyWizardFormRelayMutations_EditForSalePropertyMutation_graphql.node, convertResponse$2, convertWrapRawResponse$2);

var use$2 = RescriptRelay_Mutation.useMutation(convertVariables$2, PropertyWizardFormRelayMutations_EditForSalePropertyMutation_graphql.node, convertResponse$2, convertWrapRawResponse$2);

var EditForSalePropertyMutation_mlsListingTypeV5_decode = PropertyWizardFormRelayMutations_EditForSalePropertyMutation_graphql.Utils.mlsListingTypeV5_decode;

var EditForSalePropertyMutation_mlsListingTypeV5_fromString = PropertyWizardFormRelayMutations_EditForSalePropertyMutation_graphql.Utils.mlsListingTypeV5_fromString;

var EditForSalePropertyMutation_showingTypeV5_decode = PropertyWizardFormRelayMutations_EditForSalePropertyMutation_graphql.Utils.showingTypeV5_decode;

var EditForSalePropertyMutation_showingTypeV5_fromString = PropertyWizardFormRelayMutations_EditForSalePropertyMutation_graphql.Utils.showingTypeV5_fromString;

var EditForSalePropertyMutation = {
  mlsListingTypeV5_decode: EditForSalePropertyMutation_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: EditForSalePropertyMutation_mlsListingTypeV5_fromString,
  showingTypeV5_decode: EditForSalePropertyMutation_showingTypeV5_decode,
  showingTypeV5_fromString: EditForSalePropertyMutation_showingTypeV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$2,
  convertResponse: convertResponse$2,
  convertWrapRawResponse: convertWrapRawResponse$2,
  commitMutation: commitMutation$2,
  use: use$2
};

var convertVariables$3 = PropertyWizardFormRelayMutations_EditRentalPropertyMutation_graphql.Internal.convertVariables;

var convertResponse$3 = PropertyWizardFormRelayMutations_EditRentalPropertyMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse$3 = PropertyWizardFormRelayMutations_EditRentalPropertyMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation$3 = RescriptRelay_Mutation.commitMutation(convertVariables$3, PropertyWizardFormRelayMutations_EditRentalPropertyMutation_graphql.node, convertResponse$3, convertWrapRawResponse$3);

var use$3 = RescriptRelay_Mutation.useMutation(convertVariables$3, PropertyWizardFormRelayMutations_EditRentalPropertyMutation_graphql.node, convertResponse$3, convertWrapRawResponse$3);

var EditRentalPropertyMutation_leaseLengthValue_decode = PropertyWizardFormRelayMutations_EditRentalPropertyMutation_graphql.Utils.leaseLengthValue_decode;

var EditRentalPropertyMutation_leaseLengthValue_fromString = PropertyWizardFormRelayMutations_EditRentalPropertyMutation_graphql.Utils.leaseLengthValue_fromString;

var EditRentalPropertyMutation_mlsListingTypeV5_decode = PropertyWizardFormRelayMutations_EditRentalPropertyMutation_graphql.Utils.mlsListingTypeV5_decode;

var EditRentalPropertyMutation_mlsListingTypeV5_fromString = PropertyWizardFormRelayMutations_EditRentalPropertyMutation_graphql.Utils.mlsListingTypeV5_fromString;

var EditRentalPropertyMutation = {
  leaseLengthValue_decode: EditRentalPropertyMutation_leaseLengthValue_decode,
  leaseLengthValue_fromString: EditRentalPropertyMutation_leaseLengthValue_fromString,
  mlsListingTypeV5_decode: EditRentalPropertyMutation_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: EditRentalPropertyMutation_mlsListingTypeV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$3,
  convertResponse: convertResponse$3,
  convertWrapRawResponse: convertWrapRawResponse$3,
  commitMutation: commitMutation$3,
  use: use$3
};

var convertVariables$4 = PropertyWizardFormRelayMutations_RebroadcastForSalePropertyV5Mutation_graphql.Internal.convertVariables;

var convertResponse$4 = PropertyWizardFormRelayMutations_RebroadcastForSalePropertyV5Mutation_graphql.Internal.convertResponse;

var convertWrapRawResponse$4 = PropertyWizardFormRelayMutations_RebroadcastForSalePropertyV5Mutation_graphql.Internal.convertWrapRawResponse;

var commitMutation$4 = RescriptRelay_Mutation.commitMutation(convertVariables$4, PropertyWizardFormRelayMutations_RebroadcastForSalePropertyV5Mutation_graphql.node, convertResponse$4, convertWrapRawResponse$4);

var use$4 = RescriptRelay_Mutation.useMutation(convertVariables$4, PropertyWizardFormRelayMutations_RebroadcastForSalePropertyV5Mutation_graphql.node, convertResponse$4, convertWrapRawResponse$4);

var RebroadcastForSalePropertyMutation_mlsListingTypeV5_decode = PropertyWizardFormRelayMutations_RebroadcastForSalePropertyV5Mutation_graphql.Utils.mlsListingTypeV5_decode;

var RebroadcastForSalePropertyMutation_mlsListingTypeV5_fromString = PropertyWizardFormRelayMutations_RebroadcastForSalePropertyV5Mutation_graphql.Utils.mlsListingTypeV5_fromString;

var RebroadcastForSalePropertyMutation_showingTypeV5_decode = PropertyWizardFormRelayMutations_RebroadcastForSalePropertyV5Mutation_graphql.Utils.showingTypeV5_decode;

var RebroadcastForSalePropertyMutation_showingTypeV5_fromString = PropertyWizardFormRelayMutations_RebroadcastForSalePropertyV5Mutation_graphql.Utils.showingTypeV5_fromString;

var RebroadcastForSalePropertyMutation = {
  mlsListingTypeV5_decode: RebroadcastForSalePropertyMutation_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: RebroadcastForSalePropertyMutation_mlsListingTypeV5_fromString,
  showingTypeV5_decode: RebroadcastForSalePropertyMutation_showingTypeV5_decode,
  showingTypeV5_fromString: RebroadcastForSalePropertyMutation_showingTypeV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$4,
  convertResponse: convertResponse$4,
  convertWrapRawResponse: convertWrapRawResponse$4,
  commitMutation: commitMutation$4,
  use: use$4
};

var convertVariables$5 = PropertyWizardFormRelayMutations_RebroadcastRentalPropertyV5Mutation_graphql.Internal.convertVariables;

var convertResponse$5 = PropertyWizardFormRelayMutations_RebroadcastRentalPropertyV5Mutation_graphql.Internal.convertResponse;

var convertWrapRawResponse$5 = PropertyWizardFormRelayMutations_RebroadcastRentalPropertyV5Mutation_graphql.Internal.convertWrapRawResponse;

var commitMutation$5 = RescriptRelay_Mutation.commitMutation(convertVariables$5, PropertyWizardFormRelayMutations_RebroadcastRentalPropertyV5Mutation_graphql.node, convertResponse$5, convertWrapRawResponse$5);

var use$5 = RescriptRelay_Mutation.useMutation(convertVariables$5, PropertyWizardFormRelayMutations_RebroadcastRentalPropertyV5Mutation_graphql.node, convertResponse$5, convertWrapRawResponse$5);

var RebroadcastRentalPropertyMutation_leaseLengthValue_decode = PropertyWizardFormRelayMutations_RebroadcastRentalPropertyV5Mutation_graphql.Utils.leaseLengthValue_decode;

var RebroadcastRentalPropertyMutation_leaseLengthValue_fromString = PropertyWizardFormRelayMutations_RebroadcastRentalPropertyV5Mutation_graphql.Utils.leaseLengthValue_fromString;

var RebroadcastRentalPropertyMutation_mlsListingTypeV5_decode = PropertyWizardFormRelayMutations_RebroadcastRentalPropertyV5Mutation_graphql.Utils.mlsListingTypeV5_decode;

var RebroadcastRentalPropertyMutation_mlsListingTypeV5_fromString = PropertyWizardFormRelayMutations_RebroadcastRentalPropertyV5Mutation_graphql.Utils.mlsListingTypeV5_fromString;

var RebroadcastRentalPropertyMutation = {
  leaseLengthValue_decode: RebroadcastRentalPropertyMutation_leaseLengthValue_decode,
  leaseLengthValue_fromString: RebroadcastRentalPropertyMutation_leaseLengthValue_fromString,
  mlsListingTypeV5_decode: RebroadcastRentalPropertyMutation_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: RebroadcastRentalPropertyMutation_mlsListingTypeV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$5,
  convertResponse: convertResponse$5,
  convertWrapRawResponse: convertWrapRawResponse$5,
  commitMutation: commitMutation$5,
  use: use$5
};

var convertVariables$6 = PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation_graphql.Internal.convertVariables;

var convertResponse$6 = PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation_graphql.Internal.convertResponse;

var convertWrapRawResponse$6 = PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation_graphql.Internal.convertWrapRawResponse;

var commitMutation$6 = RescriptRelay_Mutation.commitMutation(convertVariables$6, PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation_graphql.node, convertResponse$6, convertWrapRawResponse$6);

var use$6 = RescriptRelay_Mutation.useMutation(convertVariables$6, PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation_graphql.node, convertResponse$6, convertWrapRawResponse$6);

var BroadcastQuietPropertyMutation_mlsListingTypeV5_decode = PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation_graphql.Utils.mlsListingTypeV5_decode;

var BroadcastQuietPropertyMutation_mlsListingTypeV5_fromString = PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation_graphql.Utils.mlsListingTypeV5_fromString;

var BroadcastQuietPropertyMutation_showingTypeV5_decode = PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation_graphql.Utils.showingTypeV5_decode;

var BroadcastQuietPropertyMutation_showingTypeV5_fromString = PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation_graphql.Utils.showingTypeV5_fromString;

var BroadcastQuietPropertyMutation = {
  mlsListingTypeV5_decode: BroadcastQuietPropertyMutation_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: BroadcastQuietPropertyMutation_mlsListingTypeV5_fromString,
  showingTypeV5_decode: BroadcastQuietPropertyMutation_showingTypeV5_decode,
  showingTypeV5_fromString: BroadcastQuietPropertyMutation_showingTypeV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$6,
  convertResponse: convertResponse$6,
  convertWrapRawResponse: convertWrapRawResponse$6,
  commitMutation: commitMutation$6,
  use: use$6
};

var convertFragment = PropertyWizardFormRelayMutations_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayMutations_draft_graphql.node, convertFragment, fRef);
}

function use$7(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayMutations_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayMutations_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayMutations_draft_graphql.node, convertFragment, fRef);
}

var DraftFragment_forSalePropertyTypeEnumV5_decode = PropertyWizardFormRelayMutations_draft_graphql.Utils.forSalePropertyTypeEnumV5_decode;

var DraftFragment_forSalePropertyTypeEnumV5_fromString = PropertyWizardFormRelayMutations_draft_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

var DraftFragment_leaseLengthValue_decode = PropertyWizardFormRelayMutations_draft_graphql.Utils.leaseLengthValue_decode;

var DraftFragment_leaseLengthValue_fromString = PropertyWizardFormRelayMutations_draft_graphql.Utils.leaseLengthValue_fromString;

var DraftFragment_localDraftPropertyType_decode = PropertyWizardFormRelayMutations_draft_graphql.Utils.localDraftPropertyType_decode;

var DraftFragment_localDraftPropertyType_fromString = PropertyWizardFormRelayMutations_draft_graphql.Utils.localDraftPropertyType_fromString;

var DraftFragment_mlsListingTypeV5_decode = PropertyWizardFormRelayMutations_draft_graphql.Utils.mlsListingTypeV5_decode;

var DraftFragment_mlsListingTypeV5_fromString = PropertyWizardFormRelayMutations_draft_graphql.Utils.mlsListingTypeV5_fromString;

var DraftFragment_rentalPropertyTypeEnumV5_decode = PropertyWizardFormRelayMutations_draft_graphql.Utils.rentalPropertyTypeEnumV5_decode;

var DraftFragment_rentalPropertyTypeEnumV5_fromString = PropertyWizardFormRelayMutations_draft_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

var DraftFragment_showingTypeV5_decode = PropertyWizardFormRelayMutations_draft_graphql.Utils.showingTypeV5_decode;

var DraftFragment_showingTypeV5_fromString = PropertyWizardFormRelayMutations_draft_graphql.Utils.showingTypeV5_fromString;

var DraftFragment = {
  forSalePropertyTypeEnumV5_decode: DraftFragment_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: DraftFragment_forSalePropertyTypeEnumV5_fromString,
  leaseLengthValue_decode: DraftFragment_leaseLengthValue_decode,
  leaseLengthValue_fromString: DraftFragment_leaseLengthValue_fromString,
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  mlsListingTypeV5_decode: DraftFragment_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: DraftFragment_mlsListingTypeV5_fromString,
  rentalPropertyTypeEnumV5_decode: DraftFragment_rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: DraftFragment_rentalPropertyTypeEnumV5_fromString,
  showingTypeV5_decode: DraftFragment_showingTypeV5_decode,
  showingTypeV5_fromString: DraftFragment_showingTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$7,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function getCommonAttributes(draft) {
  var match = draft.draftProperty;
  var address = match.address;
  if (address !== undefined) {
    var description = match.description;
    if (description !== undefined) {
      var match$1 = match.selectedArea;
      if (match$1 !== undefined) {
        var subject = draft.subject;
        if (subject !== undefined) {
          var message = draft.message;
          var hideAddress = match.hideAddress;
          var files = match.files.map(function (f) {
                return {
                        contentType: f.contentType,
                        fileName: f.fileName,
                        id: f.id,
                        key: f.key
                      };
              });
          var images = match.images.map(function (f) {
                return {
                        contentType: f.contentType,
                        fileName: f.fileName,
                        id: f.id,
                        key: f.key
                      };
              });
          var price = PropertyPriceInput.make(match.priceRange ? "PriceRange" : "ExactPrice", Core__Option.map(match.price, Scalars.PriceInput.fromInt), Core__Option.map(match.minPrice, Scalars.PriceInput.fromInt), Core__Option.map(match.maxPrice, Scalars.PriceInput.fromInt));
          var location_areaId = match$1.id;
          var $$location = {
            address: address,
            areaId: location_areaId
          };
          return Core__Result.map(price, (function (price) {
                        return {
                                message: message,
                                subject: subject,
                                description: description,
                                hideAddress: Core__Option.getOr(hideAddress, false),
                                images: images,
                                files: files,
                                price: price,
                                location: $$location
                              };
                      }));
        }
        
      }
      
    }
    
  }
  if (draft.subject !== undefined) {
    if (address !== undefined) {
      if (match.description !== undefined) {
        return {
                TAG: "Error",
                _0: "missing area"
              };
      } else {
        return {
                TAG: "Error",
                _0: "missing description"
              };
      }
    } else {
      return {
              TAG: "Error",
              _0: "missing address"
            };
    }
  } else {
    return {
            TAG: "Error",
            _0: "missing subject"
          };
  }
}

function getForSaleAttributes(draft) {
  return Core__Result.flatMap(getCommonAttributes(draft), (function (commonAttributes) {
                var match = draft.draftProperty;
                var forSalePropertyType = match.forSalePropertyType;
                var commission = match.commission;
                if (forSalePropertyType === undefined) {
                  return {
                          TAG: "Error",
                          _0: "missing property type"
                        };
                }
                var mlsListingType = match.mlsListingType;
                if (mlsListingType === undefined) {
                  if (match.mlsListingType !== undefined) {
                    return {
                            TAG: "Error",
                            _0: "attempted to get for-sale attributes on a rental localDraft"
                          };
                  } else {
                    return {
                            TAG: "Error",
                            _0: "missing mlsListingType"
                          };
                  }
                }
                if (match.propertyType !== "FOR_SALE") {
                  if (match.mlsListingType !== undefined) {
                    return {
                            TAG: "Error",
                            _0: "attempted to get for-sale attributes on a rental localDraft"
                          };
                  } else {
                    return {
                            TAG: "Error",
                            _0: "missing mlsListingType"
                          };
                  }
                }
                var showings = Core__Array.keepSome(match.showings).map(function (f) {
                      return {
                              date: f.date,
                              endTime: f.endTime,
                              id: f.id,
                              notes: f.notes,
                              startTime: f.startTime,
                              type: f.type_
                            };
                    });
                var tmp;
                switch (forSalePropertyType) {
                  case "CONDO" :
                      tmp = "Condo";
                      break;
                  case "LOT" :
                      tmp = "Lot";
                      break;
                  case "MULTI_UNIT" :
                      tmp = "MultiUnit";
                      break;
                  case "SINGLE_FAMILY" :
                      tmp = "SingleFamily";
                      break;
                  
                }
                var attributes = ForSalePropertyAttributesInput.make(tmp, match.beds, Core__Option.map(match.baths, (function (prim) {
                            return prim;
                          })), match.halfBaths, match.lotSize, match.livingArea, match.numberOfUnits);
                var mlsListing_goingOnMls = match.goingOnMls;
                var mlsListing_onMlsAt = match.onMlsAt;
                var mlsListing_willAcceptOffers = match.willAcceptOffers;
                var mlsListing_willShow = match.willShow;
                var mlsListing = {
                  goingOnMls: mlsListing_goingOnMls,
                  mlsListingType: mlsListingType,
                  onMlsAt: mlsListing_onMlsAt,
                  willAcceptOffers: mlsListing_willAcceptOffers,
                  willShow: mlsListing_willShow
                };
                return Core__Result.map(attributes, (function (attributes) {
                              return {
                                      message: commonAttributes.message,
                                      subject: commonAttributes.subject,
                                      description: commonAttributes.description,
                                      commission: commission,
                                      hideAddress: commonAttributes.hideAddress,
                                      showings: showings,
                                      images: commonAttributes.images,
                                      files: commonAttributes.files,
                                      attributes: attributes,
                                      price: commonAttributes.price,
                                      location: commonAttributes.location,
                                      mlsListing: mlsListing
                                    };
                            }));
              }));
}

function getRentalAttributes(draft) {
  return Core__Result.flatMap(getCommonAttributes(draft), (function (commonAttributes) {
                var match = draft.draftProperty;
                var availableFrom = match.availableFrom;
                if (availableFrom !== undefined) {
                  var leaseLength = match.leaseLength;
                  if (leaseLength !== undefined) {
                    var mlsListingType = match.mlsListingType;
                    if (mlsListingType !== undefined) {
                      var availableFrom$1 = Caml_option.valFromOption(availableFrom);
                      if (match.propertyType !== "FOR_SALE") {
                        var rentalPropertyType = match.rentalPropertyType;
                        if (rentalPropertyType !== undefined) {
                          var attributes = RentalPropertyAttributesInput.make(rentalPropertyType, match.beds, Core__Option.map(match.baths, (function (prim) {
                                      return prim;
                                    })), match.halfBaths, match.lotSize, match.livingArea);
                          var mlsListing_goingOnMls = match.goingOnMls;
                          var mlsListing_onMlsAt = match.onMlsAt;
                          var mlsListing = {
                            goingOnMls: mlsListing_goingOnMls,
                            mlsListingType: mlsListingType,
                            onMlsAt: mlsListing_onMlsAt
                          };
                          return Core__Result.map(attributes, (function (attributes) {
                                        return {
                                                message: commonAttributes.message,
                                                subject: commonAttributes.subject,
                                                description: commonAttributes.description,
                                                hideAddress: commonAttributes.hideAddress,
                                                images: commonAttributes.images,
                                                files: commonAttributes.files,
                                                attributes: attributes,
                                                price: commonAttributes.price,
                                                location: commonAttributes.location,
                                                mlsListing: mlsListing,
                                                availableFrom: availableFrom$1,
                                                leaseLength: leaseLength
                                              };
                                      }));
                        }
                        
                      }
                      
                    }
                    
                  }
                  
                }
                if (match.rentalPropertyType !== undefined) {
                  if (match.mlsListingType !== undefined) {
                    if (availableFrom !== undefined) {
                      if (match.leaseLength !== undefined) {
                        return {
                                TAG: "Error",
                                _0: "attempted to get rental attributes on a for-sale localDraft"
                              };
                      } else {
                        return {
                                TAG: "Error",
                                _0: "missing leaseLength"
                              };
                      }
                    } else {
                      return {
                              TAG: "Error",
                              _0: "missing availableFrom"
                            };
                    }
                  } else {
                    return {
                            TAG: "Error",
                            _0: "missing mlsListingType"
                          };
                  }
                } else {
                  return {
                          TAG: "Error",
                          _0: "missing property type"
                        };
                }
              }));
}

function useMutationForSubmit(draft) {
  var match = PropertyWizardFormRelay.Context.use();
  var mode = match.mode;
  var draft$1 = use$7(draft);
  var match$1 = SystemMessages.useSystemMessages();
  var addMessage = match$1.addMessage;
  var recordPropertyCreatedEvent = RecordPropertyCreatedEvent.useRecordEvent();
  var match$2 = use();
  var broadcastNewForSale = match$2[0];
  var match$3 = use$1();
  var broadcastNewRental = match$3[0];
  var match$4 = use$2();
  var editForSale = match$4[0];
  var match$5 = use$3();
  var editRental = match$5[0];
  var match$6 = use$4();
  var rebroadcastForSale = match$6[0];
  var match$7 = use$5();
  var rebroadcastRental = match$7[0];
  var match$8 = use$6();
  var broadcastQuiet = match$8[0];
  var environment = RescriptRelay.useEnvironmentFromContext();
  var invalidateProperty = function (dataId) {
    RelayRuntime.commitLocalUpdate(environment, (function (store) {
            Core__Option.forEach(Caml_option.nullable_to_opt(store.get(dataId)), (function (prim) {
                    prim.invalidateRecord();
                  }));
          }));
  };
  var router = Next.useRouter();
  var dummyReturn = function (err, onError) {
    return [
            (function (param) {
                Sentry.captureErrorMessage("Tried to submit wizard without sufficient data: " + err, true, undefined, "PropertyWizardFormRelay__Mutations.res", 495, {
                      draft: draft$1
                    }, undefined, undefined);
                onError();
              }),
            false
          ];
  };
  var onError = function () {
    var tmp;
    if (typeof mode !== "object") {
      tmp = "There was an error while creating your property";
    } else {
      switch (mode.TAG) {
        case "Edit" :
            tmp = "There was an error while saving your changes";
            break;
        case "Rebroadcast" :
            tmp = "There was an error while rebroadcasting your property";
            break;
        case "BroadcastQuietSeller" :
            tmp = "There was an error while broadcasting your property";
            break;
        
      }
    }
    addMessage(SystemMessages.Message.make(V4(), "error", tmp, 5000, undefined, undefined));
  };
  var displayNeighborhoodId = Core__Option.map(draft$1.draftProperty.displayNeighborhood, (function (d) {
          return d.id;
        }));
  var commission = draft$1.draftProperty.commission;
  if (typeof mode !== "object") {
    var match$9 = draft$1.draftProperty.propertyType;
    var match$10 = draft$1.serverDraftId;
    if (match$9 === "FOR_SALE") {
      if (match$10 === undefined) {
        return dummyReturn("missing serverDraftId", onError);
      }
      var forSaleAttributes = getForSaleAttributes(draft$1);
      if (forSaleAttributes.TAG !== "Ok") {
        return dummyReturn(forSaleAttributes._0, onError);
      }
      var forSaleAttributes$1 = forSaleAttributes._0;
      var mutationFn = function () {
        return Caml_option.some(broadcastNewForSale({
                        input: {
                          attributes: forSaleAttributes$1.attributes,
                          commission: commission,
                          description: forSaleAttributes$1.description,
                          displayNeighborhoodId: displayNeighborhoodId,
                          draftId: match$10,
                          files: forSaleAttributes$1.files,
                          hideAddress: forSaleAttributes$1.hideAddress,
                          images: forSaleAttributes$1.images,
                          location: forSaleAttributes$1.location,
                          message: forSaleAttributes$1.message,
                          mlsListing: forSaleAttributes$1.mlsListing,
                          price: forSaleAttributes$1.price,
                          showings: forSaleAttributes$1.showings,
                          subject: forSaleAttributes$1.subject,
                          website: draft$1.draftProperty.website
                        }
                      }, undefined, undefined, undefined, (function (response, mutationErrors) {
                          var match = response.broadcastForSalePropertyV5;
                          if (match !== undefined && match.__typename === "ForSalePropertyBroadcasted") {
                            var match$1 = match.client;
                            if (match$1 !== undefined && mutationErrors === undefined) {
                              recordPropertyCreatedEvent(match.property.id);
                              addMessage(SystemMessages.Message.make(V4(), "info", "Your property was broadcast to Top Agent Network", 5000, undefined, undefined));
                              return Next.Router.push("/my_clients/" + (match$1.id + "?isNew=1"), undefined, undefined, router);
                            }
                            
                          }
                          onError();
                          Sentry.captureErrorMessage("Errors broadcasting for-sale property", true, undefined, "PropertyWizardFormRelay__Mutations.res", 579, {
                                errors: mutationErrors,
                                data: response
                              }, undefined, undefined);
                        }), (function (e) {
                          Sentry.captureErrorMessage(e, true, undefined, "PropertyWizardFormRelay__Mutations.res", 593, undefined, undefined, undefined);
                          onError();
                        }), undefined));
      };
      return [
              mutationFn,
              match$2[1]
            ];
    }
    if (match$10 === undefined) {
      return dummyReturn("missing serverDraftId", onError);
    }
    var err = getRentalAttributes(draft$1);
    if (err.TAG !== "Ok") {
      return dummyReturn(err._0, onError);
    }
    var rentalAttributes = err._0;
    var mutationFn$1 = function () {
      return Caml_option.some(broadcastNewRental({
                      input: {
                        attributes: rentalAttributes.attributes,
                        availableFrom: rentalAttributes.availableFrom,
                        description: rentalAttributes.description,
                        draftId: match$10,
                        files: rentalAttributes.files,
                        hideAddress: rentalAttributes.hideAddress,
                        images: rentalAttributes.images,
                        leaseLength: rentalAttributes.leaseLength,
                        location: rentalAttributes.location,
                        message: rentalAttributes.message,
                        mlsListing: rentalAttributes.mlsListing,
                        price: rentalAttributes.price,
                        subject: rentalAttributes.subject,
                        website: draft$1.draftProperty.website
                      }
                    }, undefined, undefined, undefined, (function (response, mutationErrors) {
                        var match = response.broadcastRentalPropertyV5;
                        if (match !== undefined && match.__typename === "RentalPropertyBroadcasted") {
                          var match$1 = match.client;
                          if (match$1 !== undefined && mutationErrors === undefined) {
                            recordPropertyCreatedEvent(match.property.id);
                            addMessage(SystemMessages.Message.make(V4(), "info", "Your property was broadcast to Top Agent Network", 5000, undefined, undefined));
                            return Next.Router.push("/my_clients/" + (match$1.id + "?isNew=1"), undefined, undefined, router);
                          }
                          
                        }
                        onError();
                        Sentry.captureErrorMessage("Errors broadcasting rental property", true, undefined, "PropertyWizardFormRelay__Mutations.res", 655, {
                              errors: mutationErrors,
                              data: response
                            }, undefined, undefined);
                      }), (function (e) {
                        Sentry.captureErrorMessage(e, true, undefined, "PropertyWizardFormRelay__Mutations.res", 669, undefined, undefined, undefined);
                        onError();
                      }), undefined));
    };
    return [
            mutationFn$1,
            match$3[1]
          ];
  }
  switch (mode.TAG) {
    case "Edit" :
        var id = mode.id;
        var match$11 = draft$1.draftProperty.propertyType;
        if (match$11 === "FOR_SALE") {
          var forSaleAttributes$2 = getForSaleAttributes(draft$1);
          if (forSaleAttributes$2.TAG !== "Ok") {
            return dummyReturn(forSaleAttributes$2._0, onError);
          }
          var forSaleAttributes$3 = forSaleAttributes$2._0;
          var mutationFn$2 = function () {
            return Caml_option.some(editForSale({
                            input: {
                              attributes: forSaleAttributes$3.attributes,
                              commission: commission,
                              description: forSaleAttributes$3.description,
                              displayNeighborhoodId: displayNeighborhoodId,
                              files: forSaleAttributes$3.files,
                              hideAddress: forSaleAttributes$3.hideAddress,
                              id: id,
                              images: forSaleAttributes$3.images,
                              location: forSaleAttributes$3.location,
                              message: forSaleAttributes$3.message,
                              mlsListing: forSaleAttributes$3.mlsListing,
                              price: forSaleAttributes$3.price,
                              showings: forSaleAttributes$3.showings,
                              subject: forSaleAttributes$3.subject,
                              website: draft$1.draftProperty.website
                            }
                          }, undefined, undefined, undefined, (function (response, mutationErrors) {
                              var match = response.editForSaleProperty;
                              if (match !== undefined && match.__typename === "ForSalePropertyEdited") {
                                var match$1 = match.client;
                                if (match$1 !== undefined) {
                                  var match$2 = match.editableProperty;
                                  if (match$2 !== undefined) {
                                    var match$3 = match$2.property;
                                    if (match$3 !== undefined && mutationErrors === undefined) {
                                      addMessage(SystemMessages.Message.make(V4(), "info", "Your property has been updated", 5000, undefined, undefined));
                                      invalidateProperty(match$3.__id);
                                      return Next.Router.push("/my_clients/" + match$1.id, undefined, undefined, router);
                                    }
                                    
                                  }
                                  
                                }
                                
                              }
                              onError();
                              Sentry.captureErrorMessage("Errors editing for-sale property", true, undefined, "PropertyWizardFormRelay__Mutations.res", 734, {
                                    errors: mutationErrors,
                                    data: response
                                  }, undefined, undefined);
                            }), (function (e) {
                              Sentry.captureErrorMessage(e, true, undefined, "PropertyWizardFormRelay__Mutations.res", 748, undefined, undefined, undefined);
                              onError();
                            }), undefined));
          };
          return [
                  mutationFn$2,
                  match$4[1]
                ];
        }
        var err$1 = getRentalAttributes(draft$1);
        if (err$1.TAG !== "Ok") {
          return dummyReturn(err$1._0, onError);
        }
        var rentalAttributes$1 = err$1._0;
        var mutationFn$3 = function () {
          return Caml_option.some(editRental({
                          input: {
                            attributes: rentalAttributes$1.attributes,
                            availableFrom: rentalAttributes$1.availableFrom,
                            description: rentalAttributes$1.description,
                            displayNeighborhoodId: displayNeighborhoodId,
                            files: rentalAttributes$1.files,
                            hideAddress: rentalAttributes$1.hideAddress,
                            id: id,
                            images: rentalAttributes$1.images,
                            leaseLength: rentalAttributes$1.leaseLength,
                            location: rentalAttributes$1.location,
                            message: rentalAttributes$1.message,
                            mlsListing: rentalAttributes$1.mlsListing,
                            price: rentalAttributes$1.price,
                            subject: rentalAttributes$1.subject,
                            website: draft$1.draftProperty.website
                          }
                        }, undefined, undefined, undefined, (function (response, mutationErrors) {
                            var match = response.editRentalProperty;
                            if (match !== undefined && match.__typename === "RentalPropertyEdited") {
                              var match$1 = match.client;
                              if (match$1 !== undefined) {
                                var match$2 = match.editableProperty;
                                if (match$2 !== undefined) {
                                  var match$3 = match$2.property;
                                  if (match$3 !== undefined && mutationErrors === undefined) {
                                    addMessage(SystemMessages.Message.make(V4(), "info", "Your property has been updated", 5000, undefined, undefined));
                                    invalidateProperty(match$3.__id);
                                    return Next.Router.push("/my_clients/" + match$1.id, undefined, undefined, router);
                                  }
                                  
                                }
                                
                              }
                              
                            }
                            onError();
                            Sentry.captureErrorMessage("Errors editing rental property", true, undefined, "PropertyWizardFormRelay__Mutations.res", 810, {
                                  errors: mutationErrors,
                                  data: response
                                }, undefined, undefined);
                          }), (function (e) {
                            Sentry.captureErrorMessage(e, true, undefined, "PropertyWizardFormRelay__Mutations.res", 824, undefined, undefined, undefined);
                            onError();
                          }), undefined));
        };
        return [
                mutationFn$3,
                match$5[1]
              ];
    case "Rebroadcast" :
        var id$1 = mode._0;
        var match$12 = draft$1.draftProperty.propertyType;
        if (match$12 === "FOR_SALE") {
          var forSaleAttributes$4 = getForSaleAttributes(draft$1);
          if (forSaleAttributes$4.TAG !== "Ok") {
            return dummyReturn(forSaleAttributes$4._0, onError);
          }
          var forSaleAttributes$5 = forSaleAttributes$4._0;
          var mutationFn$4 = function () {
            return Caml_option.some(rebroadcastForSale({
                            input: {
                              attributes: forSaleAttributes$5.attributes,
                              commission: commission,
                              description: forSaleAttributes$5.description,
                              displayNeighborhoodId: displayNeighborhoodId,
                              draftId: draft$1.serverDraftId,
                              files: forSaleAttributes$5.files,
                              hideAddress: forSaleAttributes$5.hideAddress,
                              id: id$1,
                              images: forSaleAttributes$5.images,
                              location: forSaleAttributes$5.location,
                              message: Core__Option.getOr(forSaleAttributes$5.message, ""),
                              mlsListing: forSaleAttributes$5.mlsListing,
                              price: forSaleAttributes$5.price,
                              showings: forSaleAttributes$5.showings,
                              subject: forSaleAttributes$5.subject,
                              website: draft$1.draftProperty.website
                            }
                          }, undefined, undefined, undefined, (function (response, mutationErrors) {
                              var match = response.rebroadcastForSalePropertyV5;
                              if (match !== undefined && match.__typename === "ForSalePropertyRebroadcasted") {
                                var match$1 = match.client;
                                if (match$1 !== undefined) {
                                  var match$2 = match.editableProperty;
                                  if (match$2 !== undefined) {
                                    var match$3 = match$2.property;
                                    if (match$3 !== undefined && mutationErrors === undefined) {
                                      addMessage(SystemMessages.Message.make(V4(), "info", "Your property was rebroadcast to Top Agent Network", 5000, undefined, undefined));
                                      invalidateProperty(match$3.__id);
                                      return Next.Router.push("/my_clients/" + match$1.id, undefined, undefined, router);
                                    }
                                    
                                  }
                                  
                                }
                                
                              }
                              onError();
                              Sentry.captureErrorMessage("Errors rebroadcasting for-sale property", true, undefined, "PropertyWizardFormRelay__Mutations.res", 889, {
                                    errors: mutationErrors,
                                    data: response
                                  }, undefined, undefined);
                            }), (function (e) {
                              Sentry.captureErrorMessage(e, true, undefined, "PropertyWizardFormRelay__Mutations.res", 903, undefined, undefined, undefined);
                              onError();
                            }), undefined));
          };
          return [
                  mutationFn$4,
                  match$6[1]
                ];
        }
        var rentalAttributes$2 = getRentalAttributes(draft$1);
        if (rentalAttributes$2.TAG !== "Ok") {
          return dummyReturn(rentalAttributes$2._0, onError);
        }
        var rentalAttributes$3 = rentalAttributes$2._0;
        var mutationFn$5 = function () {
          return Caml_option.some(rebroadcastRental({
                          input: {
                            attributes: rentalAttributes$3.attributes,
                            availableFrom: rentalAttributes$3.availableFrom,
                            description: rentalAttributes$3.description,
                            displayNeighborhoodId: displayNeighborhoodId,
                            draftId: draft$1.serverDraftId,
                            files: rentalAttributes$3.files,
                            hideAddress: rentalAttributes$3.hideAddress,
                            id: id$1,
                            images: rentalAttributes$3.images,
                            leaseLength: rentalAttributes$3.leaseLength,
                            location: rentalAttributes$3.location,
                            message: Core__Option.getExn(rentalAttributes$3.message, undefined),
                            mlsListing: rentalAttributes$3.mlsListing,
                            price: rentalAttributes$3.price,
                            subject: rentalAttributes$3.subject,
                            website: draft$1.draftProperty.website
                          }
                        }, undefined, undefined, undefined, (function (response, mutationErrors) {
                            var match = response.rebroadcastRentalPropertyV5;
                            if (match !== undefined && match.__typename === "RentalPropertyRebroadcasted") {
                              var match$1 = match.client;
                              if (match$1 !== undefined) {
                                var match$2 = match.editableProperty;
                                if (match$2 !== undefined) {
                                  var match$3 = match$2.property;
                                  if (match$3 !== undefined && mutationErrors === undefined) {
                                    addMessage(SystemMessages.Message.make(V4(), "info", "Your property has been updated", 5000, undefined, undefined));
                                    invalidateProperty(match$3.__id);
                                    return Next.Router.push("/my_clients/" + match$1.id, undefined, undefined, router);
                                  }
                                  
                                }
                                
                              }
                              
                            }
                            onError();
                            Sentry.captureErrorMessage("Errors rebroadcasting rental property", true, undefined, "PropertyWizardFormRelay__Mutations.res", 966, {
                                  errors: mutationErrors,
                                  data: response
                                }, undefined, undefined);
                          }), (function (e) {
                            Sentry.captureErrorMessage(e, true, undefined, "PropertyWizardFormRelay__Mutations.res", 980, undefined, undefined, undefined);
                            onError();
                          }), undefined));
        };
        return [
                mutationFn$5,
                match$7[1]
              ];
    case "BroadcastQuietSeller" :
        var id$2 = mode._0;
        var forSaleAttributes$6 = getForSaleAttributes(draft$1);
        if (forSaleAttributes$6.TAG !== "Ok") {
          return dummyReturn(forSaleAttributes$6._0, onError);
        }
        var forSaleAttributes$7 = forSaleAttributes$6._0;
        var mutationFn$6 = function () {
          return Caml_option.some(broadcastQuiet({
                          input: {
                            attributes: forSaleAttributes$7.attributes,
                            commission: commission,
                            description: forSaleAttributes$7.description,
                            displayNeighborhoodId: displayNeighborhoodId,
                            draftId: draft$1.serverDraftId,
                            files: forSaleAttributes$7.files,
                            hideAddress: forSaleAttributes$7.hideAddress,
                            id: id$2,
                            images: forSaleAttributes$7.images,
                            location: forSaleAttributes$7.location,
                            message: forSaleAttributes$7.message,
                            mlsListing: forSaleAttributes$7.mlsListing,
                            price: forSaleAttributes$7.price,
                            showings: forSaleAttributes$7.showings,
                            subject: forSaleAttributes$7.subject,
                            website: draft$1.draftProperty.website
                          }
                        }, undefined, undefined, undefined, (function (response, mutationErrors) {
                            var match = response.broadcastQuietPropertyV5;
                            if (match !== undefined && match.__typename === "QuietPropertyBroadcasted") {
                              var match$1 = match.client;
                              if (match$1 !== undefined) {
                                var match$2 = match.editableProperty;
                                if (match$2 !== undefined) {
                                  var match$3 = match$2.property;
                                  if (match$3 !== undefined && mutationErrors === undefined) {
                                    addMessage(SystemMessages.Message.make(V4(), "info", "Your property was broadcast to Top Agent Network", 5000, undefined, undefined));
                                    invalidateProperty(match$3.__id);
                                    return Next.Router.push("/my_clients/" + match$1.id, undefined, undefined, router);
                                  }
                                  
                                }
                                
                              }
                              
                            }
                            onError();
                            Sentry.captureErrorMessage("Errors broadcasting quiet property", true, undefined, "PropertyWizardFormRelay__Mutations.res", 1045, {
                                  errors: mutationErrors,
                                  data: response
                                }, undefined, undefined);
                          }), (function (e) {
                            Sentry.captureErrorMessage(e, true, undefined, "PropertyWizardFormRelay__Mutations.res", 1059, undefined, undefined, undefined);
                            onError();
                          }), undefined));
        };
        return [
                mutationFn$6,
                match$8[1]
              ];
    
  }
}

exports.BroadcastForSalePropertyMutation = BroadcastForSalePropertyMutation;
exports.BroadcastRentalPropertyMutation = BroadcastRentalPropertyMutation;
exports.EditForSalePropertyMutation = EditForSalePropertyMutation;
exports.EditRentalPropertyMutation = EditRentalPropertyMutation;
exports.RebroadcastForSalePropertyMutation = RebroadcastForSalePropertyMutation;
exports.RebroadcastRentalPropertyMutation = RebroadcastRentalPropertyMutation;
exports.BroadcastQuietPropertyMutation = BroadcastQuietPropertyMutation;
exports.DraftFragment = DraftFragment;
exports.getCommonAttributes = getCommonAttributes;
exports.getForSaleAttributes = getForSaleAttributes;
exports.getRentalAttributes = getRentalAttributes;
exports.useMutationForSubmit = useMutationForSubmit;
/* commitMutation Not a pure module */
